import { MouseEvent } from "react";

import { Components, Theme } from "@mui/material/styles";

type PopupComponentOverrides = Pick<
  Components<Theme>,
  | "MuiDialog"
  | "MuiDialogActions"
  | "MuiDialogContent"
  | "MuiDialogContentText"
  | "MuiDialogTitle"
  | "MuiDrawer"
  | "MuiModal"
>;

export const popupComponentOverrides: PopupComponentOverrides = {
  // TODO Stop restyling MUI components and wrap them in our own components
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: "2rem",
      },
    },
    defaultProps: {
      slotProps: {
        paper: { onClick: (e: MouseEvent<HTMLDivElement>) => e.stopPropagation() },
      },
    },
  },
  // TODO Stop restyling MUI components and wrap them in our own components
  MuiDialogTitle: {
    defaultProps: {
      style: {
        textAlign: "center",
      },
    },
  },
  MuiDrawer: {
    defaultProps: {
      slotProps: {
        paper: { onClick: (e: MouseEvent<HTMLDivElement>) => e.stopPropagation() },
      },
    },
  },
  MuiModal: {
    defaultProps: {
      onClick: e => e.stopPropagation(),
    },
  },
};
